export type LoomPhotoItem = { url: string; label: string };

const VIEW_LABEL: Record<string, string> = {
  FRONT: "Front",
  BACK: "Back",
  SIDE_LEFT: "Left side",
  SIDE_RIGHT: "Right side",
};

export const loomPhotoLabel = (view?: string) =>
  VIEW_LABEL[String(view || "").toUpperCase()] || "Photo";

export const loomPhotoItems = (row: any): LoomPhotoItem[] => {
  const photos = Array.isArray(row?.photos) ? row.photos : [];
  const items = photos
    .filter((photo: any) => photo?.url)
    .map((photo: any) => ({
      url: String(photo.url),
      label: loomPhotoLabel(photo.view),
    }));
  if (items.length > 0) {
    return items;
  }
  if (row?.photoUrl) {
    return [{ url: String(row.photoUrl), label: "Front" }];
  }
  return [];
};
